export const SEARCH_DEBOUNCE_DELAY = 500;
export const RESULT_LIMIT = 5;
export const MIN_PATTERN_LENGTH = 3;
